import MenuIcon from '@atlaskit/icon/core/menu';
import * as React from 'react';

export function SvgMenu() {
  return <MenuIcon label="" testId="ads-refreshed-icon" />;
}
